module.exports = __webpack_public_path__ + "static/img/guanggao1.88749fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/school/guanggao1.png
// module id = uwot
// module chunks = 3